import React, { useContext, useState } from "react";
import SupplierContext from "../../../../contexts/SupplierContext";
import IOnGetAllCategoryQtySalesReportDTO from "../../../../models/DTO/IOnGetAllCategoryQtySalesReportDTO";
import ExcelJS from "exceljs/dist/exceljs.min.js";
import UserService from "../../../../services/UserService";
import UIService from "../../../../services/UIService";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import ReportPeriod from "../ReportPeriod/ReportPeriod";
import { NumericFormat } from "react-number-format";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import IOnGetCategoryQtySalesReportDTO from "../../../../models/DTO/IOnGetCategoryQtySalesReportDTO";

type Props = {
    processedReport: IProcessed_Report;
};

export const SingleCategoryQtySalesReport = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [reportData, setReportData] = useState<IOnGetCategoryQtySalesReportDTO>(
        props.processedReport.report_data as IOnGetCategoryQtySalesReportDTO
    );

    const downloadExcel = () => {
        if (reportData) {
            const workbook = new ExcelJS.Workbook();
            const ws = workbook.addWorksheet(`${reportData.categoryName} Report Data`);

            const columns: (
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
                | { header: string; key: string }
            )[] = [
                { header: "Account", key: "account" },
                { header: "Total Qty.", key: "qty_sold" },
            ];

            ws.columns = columns;

            ws.getCell("A1").font = {
                bold: true,
            };

            ws.getCell("B1").font = {
                bold: true,
            };

            let totalQtySold = 0;

            for (const account of Object.keys(reportData.accounts)) {
                // @ts-expect-error
                const detail = reportData.accounts[account];
                const name: string = detail.vendorName;
                const qty_sold = detail.qtySold;
                totalQtySold += qty_sold;

                ws.addRow({ account: name, qty_sold });
            }

            const totalRow = ws.addRow({
                qty_sold: totalQtySold,
            });
            totalRow.font = {
                bold: true,
            };
            totalRow.border = {
                top: {
                    style: "thick",
                },
            };

            // const periodStart = moment(reportData.periodStart).format("YYYY-MM-DD");
            // const periodEnd = moment(reportData.periodEnd).format("YYYY-MM-DD");

            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `orderwerks-${reportData.categoryName}-report-${UserService.parseLastUpdated(
                    props.processedReport.created_at
                )}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });
        }
    };

    const tableDark = UIService.isMainViewLight() ? "" : "table-dark";

    return (
        <div className={"SingleCategoryQtySalesReport"}>
            {reportData && reportData.totalQtySold > 0 ? (
                <OwButton
                    leftIconClass={"fad fa-file-excel"}
                    className={"btn-primary d-print-none"}
                    title={"export_to_excel"}
                    fn={downloadExcel}
                />
            ) : null}
            <div>
                <OwTitle title={"category_qty_sales_report"} tag={"h3"} />
                <OwTitle title={reportData.categoryName} disableTranslation={true} tag={"h4"} />
                <OwLabel title={"created_at"} postText={":"} className={"me-2"} />
                {UserService.parseLastUpdated(props.processedReport.created_at)}
            </div>

            <ReportPeriod className={"mt-3"} startDate={reportData.startDate} endDate={reportData.endDate} />

            <div>
                <table className={`table table-sm ${tableDark}`}>
                    <thead>
                        <tr>
                            <th scope={"col"}>
                                <OwLabel title={"account"} />
                            </th>
                            <th className={"text-end"} scope={"col"}>
                                <OwLabel title={"qty"} />
                            </th>
                        </tr>
                    </thead>
                    {Object.keys(reportData.accounts).map((accountName) => {
                        return (
                            <tbody key={accountName}>
                                <tr>
                                    <td>{accountName}</td>
                                    <td className={"text-end"}>
                                        <NumericFormat
                                            value={reportData.accounts[accountName].qtySold}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={supplierModel.pricing_precision || 2}
                                            fixedDecimalScale={true}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })}

                    <tbody>
                        <tr>
                            <td></td>
                            <td className={"text-end"}>
                                <b>
                                    <NumericFormat
                                        value={reportData.totalQtySold}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={supplierModel.pricing_precision || 2}
                                        fixedDecimalScale={true}
                                    />
                                </b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
